import React from 'react';
import { BusyOverlayContainer } from './BusyOverlayStyles';

const BusyOverlay = () => (
  <BusyOverlayContainer>
    <svg width="180" height="120" viewBox="0 0 180 120" style={{ display: 'block', margin: '60px auto 0 auto' }}>
      <text x="90" y="70" textAnchor="middle" fontSize="30" fill="#fff" fontFamily="sans-serif">
        Please wait...
      </text>
    </svg>
  </BusyOverlayContainer>
);

export default BusyOverlay;
